import { Skeleton } from "@mui/material";
import React from "react";

const TableSkeleton = () => {
  return (
    <div style={{ width: "100%" }}>
      {[...Array(7)].map((_, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <Skeleton sx={{ width: "15%", height: "50px" }} />
          <Skeleton sx={{ width: "25%", height: "50px" }} />
          <Skeleton sx={{ width: "20%", height: "50px" }} />
          <Skeleton sx={{ width: "20%", height: "50px" }} />
          <Skeleton sx={{ width: "10%", height: "50px" }} />
        </div>
      ))}
    </div>
  );
};

export default TableSkeleton;
